import StudentRow from "./StudentRow";
import AdminRow from "./AdminRow";
import TeacherRow from "./TeacherRow";
import ClassRow from "./ClassRow";
import { useContext } from "react";
import { EntityManagementContext } from "../context/EntityManagementContext";

function EntityTable(props) {
    let oddRow = true;

    const {
        setMode,
        openPopup,
    } = useContext(EntityManagementContext);

    function rowColorClass(oddRow){
        return "user-row " + (oddRow ? "a-row" : "b-row");
    }

    function createUserButtonPress() {
        setMode("Create");
        openPopup();
    }

    return (
        <div id="table-area">
            <div id="table-utility">
                <button id="create-user-button" onClick={createUserButtonPress}>Create New {props.type}</button>
                {/* TODO: Implement search */}
                {/*<div>*/} {/* Search bar */}
                {/* <input placeholder={"Search for a " + props.type + "..."}/> */}
                {/* <button>Search</button> */}
                {/*</div>*/}
            </div>
            <table id="user-table">
                <thead>
                    <tr id="table-header">
                        {props.headers.map((header) => {
                            return <th>{header}</th>
                        })}
                    </tr>
                </thead>
                <tbody>
                    {(props.users && props.users.length >= 1) ?
                        (props.type == "Student" ?
                            (props.users.map((student) => {
                                oddRow = !oddRow;
                                return <tr className={rowColorClass(oddRow)}>
                                            <StudentRow 
                                                id={student.id}
                                                key={student.id} 
                                                row={oddRow ? "a" : "b"} 
                                                name={student.first_name + " " + student.last_name} 
                                                email={student.email} 
                                                classes={student.classes} 
                                                age={student.age} /></tr>
                            }))
                            : (props.type == "Teacher" ?
                                (props.users.map((teacher) => {
                                    oddRow = !oddRow;
                                    return <tr className={rowColorClass(oddRow)}>
                                                <TeacherRow 
                                                    id={teacher.id}
                                                    key={teacher.id}
                                                    name={teacher.first_name + " " + teacher.last_name} 
                                                    email={teacher.email} 
                                                    classes={teacher.classes}/></tr>
                                }))
                                : (props.type == "Admin" ?
                                    (props.users.map((admin) => {
                                        oddRow = !oddRow;
                                        return <tr className={rowColorClass(oddRow)}>
                                                    <AdminRow 
                                                        id={admin.id}
                                                        key={admin.id}
                                                        row={oddRow ? "a" : "b"} 
                                                        name={admin.first_name + " " + admin.last_name} 
                                                        email={admin.email} /></tr>
                                    }))
                                    : (props.type == "Class" ?
                                        (props.users.map((classObj) => {
                                            oddRow = !oddRow;
                                            return <tr className={rowColorClass(oddRow)}>
                                                        <ClassRow 
                                                            id={classObj.classID}
                                                            user={props.user} 
                                                            key={classObj.classID}
                                                            row={oddRow ? "a" : "b"} 
                                                            name={classObj.className} 
                                                            teacher={classObj.teacher} 
                                                            grade={classObj.classGrade} /></tr>
                                        }))
                                        : null))))
                        : <tr><td style={{ textAlign: "center", fontStyle: "italic" }}>No {props.type.toLowerCase()} records found.</td></tr>}
                </tbody>
            </table>
        </div>
    );
}

export default EntityTable;